import { useEffect, useRef, useState } from "react";
import {
    FaChevronDown,
    FaMagnifyingGlass,
    FaWifi,
} from "react-icons/fa6";
import { useHookPppoeProfile } from "../../../hooks/useHookPppoeProfile";

export const SelectProfile = ({
    label,
    value,
    setValue,
    setPrice,
    placeholder = "Pilih Profile",
    searchable = true,
}) => {
    const hookResult = useHookPppoeProfile();

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");

    const wrapperRef = useRef(null);

    const rawData = hookResult?.data?.data
        ? hookResult.data.data
        : hookResult?.data;

    const safeData = Array.isArray(rawData) ? rawData : [];


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target)
            ) {
                setOpen(false);
                setSearch("");
            }
        };

        document.addEventListener(
            "mousedown",
            handleClickOutside
        );

        return () =>
            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );
    }, []);


    const selected = safeData.find(
        (o) => o.id === value
    );


    const filteredOptions = safeData.filter((o) =>
        o?.name
            ?.toLowerCase()
            .includes(search.toLowerCase())
    );


    return (
        <div
            className="w-full relative"
            ref={wrapperRef}
        >

            {label && (
                <label className="block text-xs font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">
                    {label}
                </label>
            )}


            {/* SELECT BOX */}
            <div
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between px-3 py-2.5 rounded-xl bg-slate-800/60 border border-slate-600/40 cursor-pointer transition-all duration-200"
                style={{
                    borderColor: open
                        ? "rgba(0,180,216,.5)"
                        : "rgba(71,85,105,.4)",

                    boxShadow: open
                        ? "0 0 0 1px rgba(0,180,216,.2)"
                        : "none",
                }}
            >

                <div className="flex items-center gap-2 min-w-0">

                    <FaWifi className="text-slate-500 text-xs flex-shrink-0" />

                    <span
                        className={
                            selected
                                ? "text-gray-100 whitespace-nowrap"
                                : "text-slate-500 whitespace-nowrap"
                        }
                    >
                        {selected
                            ? selected.name
                            : placeholder}
                    </span>

                </div>


                <FaChevronDown
                    className={`
                        text-xs text-slate-500 
                        ml-3 flex-shrink-0
                        transition-transform duration-200
                        ${open ? "rotate-180" : ""}
                    `}
                />

            </div>



            {/* DROPDOWN */}
            {open && (
                <div
                    className="
                        absolute
                        z-[1000]
                        mt-2
                        rounded-xl
                        shadow-2xl
                        shadow-black/40
                        overflow-hidden

                        min-w-max
                        max-w-[calc(100vw-2rem)]
                    "
                    style={{
                        background:
                            "rgba(15,23,42,.95)",

                        border:
                            "1px solid rgba(51,65,85,.5)",

                        backdropFilter:
                            "blur(16px)",
                    }}
                >


                    {/* SEARCH */}
                    {searchable && (
                        <div
                            className="
                                p-2.5
                                min-w-[260px]
                            "
                            style={{
                                borderBottom:
                                    "1px solid rgba(51,65,85,.3)",
                            }}
                        >

                            <div className="relative">

                                <FaMagnifyingGlass
                                    className="
                                        absolute
                                        left-3
                                        top-1/2
                                        -translate-y-1/2
                                        text-slate-500
                                        text-xs
                                    "
                                />


                                <input
                                    autoFocus
                                    type="text"
                                    placeholder="Cari Profile..."
                                    value={search}

                                    onChange={(e) =>
                                        setSearch(
                                            e.target.value
                                        )
                                    }

                                    className="
                                        w-full
                                        pl-9
                                        pr-3
                                        py-2
                                        text-sm
                                        rounded-lg

                                        bg-slate-800/80

                                        border
                                        border-slate-600/30

                                        text-gray-100

                                        placeholder-slate-500

                                        outline-none

                                        focus:border-cyan-500/50

                                        focus:ring-1

                                        focus:ring-cyan-500/20

                                        transition-all
                                    "
                                />

                            </div>

                        </div>
                    )}




                    {/* LIST */}
                    <div
                        className="
                            max-h-56
                            overflow-y-auto
                            overflow-x-auto
                            py-1
                        "
                    >


                        {/* RESET */}
                        <div
                            onClick={() => {

                                setValue("");

                                setPrice?.("");

                                setOpen(false);

                                setSearch("");

                            }}

                            className={`mx-1 px-3 py-2.5

                                rounded-lg

                                cursor-pointer

                                flex
                                items-center
                                gap-2

                                whitespace-nowrap

                                text-sm

                                transition-all

                                ${value === ""
                                    ?
                                    "bg-cyan-600/15 text-cyan-400 font-semibold"
                                    :
                                    "text-slate-400 hover:bg-slate-700/40 hover:text-gray-100"
                                }
                            `}
                        >
                            <FaWifi className="text-xs" />
                            <span>
                                Semua Profile
                            </span>
                        </div>
                        {filteredOptions.length === 0 ? (

                            <div className="
                                px-5
                                py-6
                                text-center
                                text-slate-500
                                text-sm
                                italic
                            ">
                                Profile tidak ditemukan
                            </div>


                        ) : (

                            filteredOptions.map((opt) => (

                                <div

                                    key={opt.id}

                                    onClick={() => {

                                        setValue(opt.id);

                                        setPrice?.(
                                            opt.price
                                        );

                                        setOpen(false);

                                        setSearch("");

                                    }}


                                    className={`mx-1 px-3 py-2.5 rounded-lg cursor-pointer flex items-center justify-between gap-5 whitespace-nowrap text-sm transition-all
                                        ${value === opt.id
                                            ?
                                            "bg-cyan-600/15 text-cyan-400 font-semibold"
                                            :
                                            "text-slate-300 hover:bg-slate-700/40 hover:text-gray-100"
                                        }
                                    `}
                                >
                                    <div className="
                                        flex
                                        items-center
                                        gap-2
                                    ">
                                        <FaWifi
                                            className="
                                                text-xs
                                                opacity-60
                                                flex-shrink-0
                                            "
                                        />
                                        <span>
                                            {opt.name}
                                        </span>

                                    </div>
                                    {opt.price && (
                                        <span
                                            className="
                                                text-xs
                                                text-cyan-400
                                            "
                                        >
                                            Rp{" "}
                                            {Number(
                                                opt.price
                                            ).toLocaleString(
                                                "id-ID"
                                            )}
                                        </span>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};